import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Button, Field } from '../src';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "custom-error-messages"
    }}>{`Custom Error Messages`}</h1>
    <p>{`If you want to display your own error messages, use the `}<inlineCode parentName="p">{`errorMessage`}</inlineCode>{` property on the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{`, `}<inlineCode parentName="p">{`<Select/>`}</inlineCode>{`, or `}<inlineCode parentName="p">{`<RadioGroup/>`}</inlineCode>{` component.`}</p>
    <Playground __position={0} __code={'<Form>\n  <div>\n    <div>Email</div>\n    <Field\n      id=\"email\"\n      type=\"email\"\n      required\n      errorMessage=\"This is a custom error message!\"\n    />\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Button,
      Field,
      Playground
    }} mdxType="Playground">
  <Form mdxType="Form">
    <div>
      <div>Email</div>
      <Field id="email" type="email" required errorMessage="This is a custom error message!" mdxType="Field" />
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      